class Autoplay {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        this.listItems = document.querySelectorAll('[data-autoplay]')

        window.addEventListener('scroll', () => {
            this.update()
        })
        window.addEventListener('resize', () => {
            this.update()
        })

        this.update()
    }
    update() {
        this.listItems.forEach((item) => {
            const rect = item.getBoundingClientRect()
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0
            if (isVisible) {
                item.play()
            } else {
                item.pause()
            }
        })
    }
}

export default Autoplay